export default __webpack_public_path__ + "static/media/javanese.dde8949e.ttf";